import label from "@/lang/StaticLabels.js";

// PHAMSAZ Navbar  - همساز -----------------------------------------------
let navItems = [
  {
    title: label.modules.phamsaz,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PHAMSAZDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      // {
      //   to: "PHAMSAZProjectType",
      //   label: label.menu.projectType,
      //   metaLabel: label.page.projectType,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },

      {
        to: "PHAMSAZEstimationSubject",
        label: label.menu.estimationSubject,
        metaLabel: label.page.estimationSubject,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMSAZCrimesRewardSubject",
        label: label.menu.crimesRewardSubject,
        metaLabel: label.page.crimesRewardSubject,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMSAZUnit",
        label: label.menu.unit,
        metaLabel: label.page.unit,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMSAZSetting",
        label: label.menu.settings,
        metaLabel: label.page.settings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMSAZMessageSetting",
        label: label.menu.messageSetting,
        metaLabel: label.page.messageSetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: "PHAMSAZProjectList",
        label: label.menu.projects,
        metaLabel: label.page.projects,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      // {
      //   to: "PHAMSAZBlock",
      //   label: label.menu.blocks,
      //   metaLabel: label.page.blocks,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      {
        to: "PHAMSAZSuiteList",
        label: label.menu.suite,
        metaLabel: label.page.suite,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PHAMSAZParticipationList",
        label: label.menu.participation,
        metaLabel: label.page.participation,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PHAMSAZPaymentNotificationList",
        label: label.menu.paymentNotifications,
        metaLabel: label.page.paymentNotifications,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      // {
      //   to: "PHAMSAZGeneralEstimate",
      //   label: label.menu.generalEstimate,
      //   metaLabel: label.page.generalEstimate,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      {
        to: "PHAMSAZEstimatesList",
        label: label.menu.estimates,
        metaLabel: label.page.estimates,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      // {
      //   to: "PHAMSAZRankingList",
      //   label: label.menu.rankings,
      //   metaLabel: label.page.rankings,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: true,
      //   subItems: [],
      // },
      {
        to: "PHAMSAZCrimesRewardList",
        label: label.menu.crimesReward,
        metaLabel: label.page.crimesReward,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PHAMSAZMemberDepositList",
        label: label.menu.memberDeposit,
        metaLabel: label.page.memberDeposit,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PHAMSAZOffsetList",
        label: label.menu.hamsazOffset,
        metaLabel: label.page.hamsazOffset,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PHAMSAZTransfersList",
        label: label.menu.transfers,
        metaLabel: label.page.transfers,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: "PHAMSAZReceiveChequeList",
        label: label.menu.receivableDocs,
        metaLabel: label.page.receiveCheque,
        icon: "mdi-subdirectory-arrow-left",
        active: true,
        subItems: [],
      },
      {
        to: null,
        label: label.menu.cartables,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PHAMSAZMemberDepositChequeCartable",
            label: label.menu.memberDepositChequeCartable,
            metaLabel: label.page.memberDepositChequeCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PHAMSAZMemberDepositCashCartable",
            label: label.menu.memberDepositCashCartable,
            metaLabel: label.page.memberDepositCashCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PHAMSAZOffsetVoucherCartable",
            label: label.menu.hamsazOffsetVoucherCartable,
            metaLabel: label.page.hamsazOffsetVoucherCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PHAMSAZTransferVoucherCartable",
            label: label.menu.transferVoucherCartable,
            metaLabel: label.page.transferVoucherCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: "PHAMSAZRankingReport",
        label: label.menu.rankings,
        metaLabel: label.page.rankings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
